import styled from 'styled-components';

const PointOfSalesContainer = styled.div`
  width: 100%;
  .showAllContainer {
    margin-left: auto;
    margin-right: auto;
    width: 200px;
  }

  .linkContainer {
    display: flex;
    text-decoration: none;
  }
  .prepareMyTrip {
    display: inline-flex;
    align-items: center;
    margin-left: 5px;
    text-decoration: none;
    p {
      display: none;
      margin-right: 5px;
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      font-size: 12px;
      color: #2b3d54;
    }

    :hover {
      p {
        display: block;
      }
    }
  }

  .rightComponentsHeader {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .exportButtonContainer {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  .buttonColumns {
    margin-right: 10px;
    border: 0.8px black solid;
    background-color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: ${(props) => props.theme.colors.black};
    border-radius: 24px;
    height: 30px;
    white-space: nowrap;
    padding-left: 15px;
    padding-right: 15px;

    p {
      margin-left: 10px;
      font-size: 12px;
    }

    span {
      color: ${(props) => props.theme.colors['terra-cotta']};
    }
  }

  .buttonColumns:hover {
    opacity: 0.6;
    cursor: pointer;
  }

  .topContentModal {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .modalSubtitle {
    text-transform: uppercase;
    color: #2b3d54;
    font-family: ${(props) => props.theme.fonts.oswald};

    span {
      color: ${(props) => props.theme.colors['terra-cotta']};
      margin-left: 5px;
    }
  }

  .topRightContentModal {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: auto;

    .displayAll {
      color: #153749;
      font-size: 12px;
      font-family: ${(props) => props.theme.fonts.sfcompact};
      margin-left: 10px;
    }
  }

  .listColumns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 50px;
    width: 100%;
  }

  .columnItem {
    width: calc(100% - 40px);
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 20px 20px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .itemLabel {
    margin-left: 10px;
    font-size: 12px;
    color: #153749;
  }

  .itemValue {
    margin-left: auto;
    color: #153749;
    opacity: 0.5;
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_italic};
  }

  .columnItemDark {
    background-color: rgba(245, 245, 245, 0.8);
  }

  .tableContainer {
    width: calc(100vw - 185px);
  }
`;

const Split = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  margin: 20px 0;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

const PillPos = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  p {
    margin-left: 4px;
    white-space: nowrap;
  }
`;

export { PointOfSalesContainer, PillPos, Split };
